import React from "react"
import { Tooltip } from "antd"
import PropTypes from "prop-types"
import "./IconCellRenderer.scss"

const IconCellRenderer = ({
  iconClassName,
  onClick,
  isAllowed = true, // TODO: rename to disabled
  tooltip,
  ...props
}) => {
  // disabled state can be based on cell renderer props
  const disabled =
    (typeof isAllowed === "boolean" && isAllowed === false) ||
    (typeof isAllowed === "function" && isAllowed(props) !== true)

  let className = ["icon-renderer"]
    .concat(iconClassName ? [iconClassName] : [])
    .concat(disabled ? ["icon-renderer-disabled"] : [])
    .join(" ")

  let content = (
    <i
      className={className}
      onClick={onClick && !disabled ? () => onClick(props) : null}
    />
  )

  // result of a tooltip function to determine using column params
  if (typeof tooltip === "function" && !!tooltip(props)) {
    return <Tooltip title={tooltip(props)}>{content}</Tooltip>
  }

  // tooltip is string or node
  if (typeof tooltip !== "function" && !!tooltip) {
    return <Tooltip title={tooltip}>{content}</Tooltip>
  }

  return content
}

IconCellRenderer.propTypes = {
  iconClassName: PropTypes.string,
  onClick: PropTypes.func,
  isAllowed: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  tooltip: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node]),
}

export default IconCellRenderer
